import type { ReactNode } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { IconBadge } from "@/components/waggle/PageShell";

/** Stand-in for a settings section whose ticket has not landed yet. */
export function PlaceholderSection({ id, title, description, icon }: { id: string; title: string; description: string; icon: ReactNode }) {
  return (
    <Card className="shadow-none" data-testid={`settings-placeholder-${id}`}>
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-center gap-4 rounded-xl border border-dashed px-6 py-10 text-center">
          <IconBadge tone="muted">{icon}</IconBadge>
          <div>
            <p className="text-sm font-semibold">Coming soon</p>
            <p className="mt-1 text-sm text-muted-foreground">There's nothing to change here yet.</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
